import { Antwoord, Vraag, VariableContent } from '@models/claims';
import { VraagboomAntwoord, VraagboomMultiResultaat, VraagboomNumberResultaat, VraagboomTextResultaat } from '@models/vragenboom';
import { VariableHelper } from './variable-helper';

export class MultiResultaatMapper {
  public static mapResultaten(vraagboomAntwoord: VraagboomAntwoord<VraagboomMultiResultaat>, variabeleContent: VariableContent[], vragen: Vraag[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag == null)
      return;

    vraag.id = vraagboomAntwoord.vraag.id;

    for (const antwoord of vraagboomAntwoord.antwoorden) {
      vraag.antwoorden.push(new Antwoord({ id: antwoord.id }));
    }

    vragen.push(vraag);

    vraagboomAntwoord.resultaat.resultaten.forEach((value, key) => {
      if (value == null)
        return;

      const antwoord = vraagboomAntwoord.vraag.antwoorden.find(x => x.id === key);
      if (antwoord == null)
        return;

      const variable: string = VariableHelper.extractVariable(antwoord.variabeleWaarde);
      if (variable == null)
        return;

      let newVariableValue: string;
      if (value instanceof VraagboomNumberResultaat)
        newVariableValue = (value as VraagboomNumberResultaat).value;
      else if (value instanceof VraagboomTextResultaat)
        newVariableValue = (value as VraagboomTextResultaat).value;
      else
        return;

      variabeleContent.push(new VariableContent(vraagboomAntwoord.vraag.id, antwoord.id, variable, newVariableValue));
    });
  }
}
